import styled from 'styled-components'

export const Color = styled.span`
  color: ${({ theme, color }) => theme.color[color]};
`
